<template>
 <v-dialog v-model="dialogNote" max-width="500px" persistent max-height="500px" style="overflow-y: hidden;">
  <v-card style="border-radius:20px;">
  <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai"><v-icon color="white">fas fa-sticky-note</v-icon>&nbsp;&nbsp;{{$t('Dialog.note.headerNote')}}</v-toolbar-title>
        <v-spacer></v-spacer>
          <div v-if="token == datanote.owner && !edit">
            <!-- <v-menu bottom offset-y >
              <v-btn dark icon flat slot="activator" row wrap>
                <v-icon style="font-size: 15px !important;">more_vert</v-icon>
              </v-btn>
              <v-list style="width: 140px;">
                <v-list-tile  @click="edit = !edit" >
                  <v-icon style="font-size: 15px;">mdi-pencil</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai"> {{$t('AnswerQuestion.edit')}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile  @click="remove" >
                  <v-icon style="font-size: 15px;">far fa-trash-alt</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai"> {{$t('AnswerQuestion.remove')}}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu> -->
            <header class="headerUser" style="z-index: 8 !important;" id="headerMenubarUser" v-if="statemember != 'block'">
               <nav class="headerUser__nav" >
                 <ul class="headerUser__navbar">
                   <li class="headerUser__item">
                     <a href="#" class="headerUser__link">
                       <button class="headerUser--btn" key="off" @click="show = !show">
                         <v-icon  class="headerUser--icon">more_vert</v-icon>
                        </button>
                     </a>
                     <transition name="dropdown">
                       <div class="headerUser__dropdown-menu" v-bind:class="{ active: show }" v-if="show">
                         <ul class="headerUser__dropdown-menu-nav">
                           <li class="header__dropdown-menu-item" @click="clickedit()" >
                             <a href="#" class="header__dropdown-menu-link">
                               <div class="header__dropdown-menu-svg">
                                 <v-icon meduim class="header--icon--menu font-size15">mdi-pencil</v-icon>
                               </div>
                               <div class="header__dropdown-menu-text">
                                 {{$t('AnswerQuestion.edit')}}
                               </div>
                             </a>
                           </li>
                           <li class="header__dropdown-menu-item" @click="remove">
                             <a href="#" class="header__dropdown-menu-link">
                               <div class="header__dropdown-menu-svg">
                                 <v-icon meduim class="header--icon--menu font-size15">far fa-trash-alt</v-icon>
                               </div>
                               <div class="header__dropdown-menu-text">
                                 {{$t('AnswerQuestion.remove')}}
                               </div>
                             </a>
                           </li>
                         </ul>
                       </div>
                     </transition>
                   </li>
                 </ul>
               </nav>
             </header>
          </div>
        <v-btn dark icon flat @click="closeDialog">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
  <v-card-text  style="padding-left: 30px;">
    <v-progress-linear :indeterminate="progress" v-if="status == 'progress'"></v-progress-linear>
    <div v-else-if="status == 'show'">
        <v-layout align-center justify-start row wrap>
          <v-avatar class="user-photonote" style="cursor: pointer;" @click="openPictureProfile(datanote.profilepicture, datanote.type)">
            <img v-if="datanote.profilepicture" :src="datanote.profilepicture" class="alligator-turtle">
            <img v-else-if="datanote.type ==='business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
            <img v-else-if="datanote.type ==='bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
            <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
          </v-avatar>
          <p style="font-size: 18px; padding-left: 10px; padding-top: 10px;" class="text2">{{datanote.nickname}}</p>
          <span style="font-size: 10px;position: absolute;right: 10px;color: #5a616b !important;">
            {{date(datanote.create_date)}} {{time(datanote.create_date)}}
          </span>
        </v-layout>
        <div style="max-height:200px; min-height:100px; margin-top: 10px; word-break: break-all;" class="scrolling-wrapper">
          <div v-if="edit" style="width: 100%;" >
            <textarea v-model="edittext" style="resize: none;  width: 100%; height: 150px; background: #1a222b12;padding: 20px;border-radius: 15px;" class="scrolling-wrapper">
            </textarea>
          </div>
        <p v-else style="" class="" v-html="convert(datanote.note_data.text ).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
        </div>
        <div>
          <v-layout align-center justify-center row wrap>
            <v-flex xs6 md6 sm6>
              <v-layout align-center justify-end row wrap style="padding-right: 10px;">
                <v-btn @click="cancel" v-if="token == datanote.owner && edit" class="btncancel CSChatThai">{{$t('AnswerQuestion.cancel')}}
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs6 md6 sm6>
              <v-layout align-center justify-start row wrap>
                <v-btn @click="save" v-if="token == datanote.owner && edit" :disabled="edittext == preedittext" class="btnallow CSChatThai">{{$t('AnswerQuestion.ok')}}
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </div>
    <div v-else-if="status == 'error'" style="text-align: center;">
      <br>
       <v-icon style="color: #757575 !important; font-size: 80px !important;">error_outline</v-icon>
       <br><br>
      <p style="font-size: 20px; color: #757575;"> {{errormessage}} </p>
    </div>



  </v-card-text>


</v-card>
    <ShowImageProfileDialog :dialogshowimage_profile="dialogshowimage_profile" :pathpicture="pathpicture" :typepathpicture="typepathpicture" @closeDialogShowImage_Profile="closeDialogShowImage_Profile"/>
</v-dialog>
<!-- <v-dialog v-model="dialognote" v-else></v-dialog> -->
</template>
<script>
import ShowImageProfileDialog from '@/components/chat/dialog/ShowImage_ProfileDialog'
import { Momenttime, Decode } from '@/services'

export default {
  props: {
    dialogNote: false,
    note_id: '',
    statemember: String
    },
  data: () => ({
    datanote: {note_data: {text: 'test'}},
    token: '',
    edit: false,
    edittext: '',
    preedittext: '',
    progress: true,
    status: 'show',
    errormessage: '',
    dialogshowimage_profile: false,
    pathpicture: '',
    typepathpicture: '',
    show: false,
    block_st : ''
  }),
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    // console.log(this.note_id)
    // console.log(this.status_block)
  },
  components: {
    ShowImageProfileDialog
  },
  mounted(){

  },
  methods: {
    clickedit () {
      this.edit = !this.edit
      this.show = false
    },
    openPictureProfile (picture, type) {
      this.pathpicture = picture
      this.typepathpicture = type
      this.dialogshowimage_profile = true
    },
    closeDialogShowImage_Profile (value) {
      this.dialogshowimage_profile = value
    },
    closeDialog () {
      this.$emit('closeNote', false)
      this.edit = false
    },
    remove () {
      this.show = false
      this.$swal({
        text: this.$t('Alert.Right.removeNote'),
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APImanage + '/removenote', {note_id: this.note_id, tokenuser: this.token}).then((response) => {
            if (response.data.status === 'success') {
              this.status = 'error'
              this.errormessage = this.$t('Dialog.note.noNote')
              this.$emit('removeNote', this.note_id)
              this.closeDialog()
            } else {
              this.$swal(
                '',
                this.$t('Alert.Fail.default.somethingWrong'),
                'error'
              )
            }
          })
        }
      })
    },
    save () {
      this.edit = false
      if (this.edittext !== this.preedittext) {
        this.datanote.note_data.text = this.edittext
        this.preedittext = this.edittext
        this.axios.post(process.env.APImanage + '/editnote', {note_id: this.note_id, tokenuser: this.token, text: this.edittext}).then((response) => {
          if (response.data.status === 'success') {
            // console.log(response.data)
            this.$emit('editNote', this.edittext, this.note_id)
          } else {
            this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
          }
        }, () => {
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
        })
      }
    },
    cancel () {
      this.edit = false
      this.edittext = this.preedittext
    },
    date (timestamp) {
      return Momenttime.momentdatethai(timestamp)
    },
    time (timestamp) {
      return Momenttime.momenttimethai(timestamp)
    },
    convert (msg) {
      var text = msg
      var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/\\%?=~_|!:,.;]*[-A-Z0-9+&@#/\\%=~_|])/ig
      var text1 = text.replace(/</g, '&lt;')
      var text2 = text1.replace(/>/g, '&gt;')
      var text3 = text2.replace(exp, '<a target="_blank" href="$1">$1</a>')
      var exp2 = /(^|[^/\\])(www\.[\S]+(\b|$))/gim
      var text4 = text3.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>')
      return text4
    }
  },
  watch: {
    dialogNote () {
      if (this.dialogNote) {
        console.log(this.statemember)
        // this.datanote.note_data.text = 'test'
        this.progress = true
        this.status = 'progress'
        this.axios.post(process.env.APImanage + '/getnote', {note_id: this.note_id}).then((response) => {
          if (response.data.list_note.length !== 0) {
            this.status = 'show'
            this.progress = false
            this.datanote = response.data.list_note[0]
            this.edittext = response.data.list_note[0].note_data.text
            this.preedittext = response.data.list_note[0].note_data.text
          } else {
            this.progress = false
            this.status = 'error'
            this.errormessage = this.$t('Dialog.note.noNote')
          }
        })
      }
    }
  }
}
</script>
<style type="text/css" scoped>
.btnallow {
  font-size: 13px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #2562af !important;
  color: white !important;
  text-transform: none;
}
.btncancel {
  font-size: 13px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #e0e0e0 !important;
  color: black !important;
  text-transform: none;
}

.scrolling-wrapper {
  resize: none;
  display: flex;
  overflow-y: auto;
}
.scrolling-wrapper:focus {
  border:none;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 10px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}

.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
.application .theme--light.input-group input, .application .theme--light.input-group textarea, .theme--light .input-group input, .theme--light .input-group textarea {
    /* color: rgba(0,0,0,.87); */
    color: #53ceff !important;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.user-photonote{
  height: 40px !important;
  width: 40px !important;
  background: #ccc;
  border-radius: 50%;
  overflow: hidden;

}

.textchat {
  white-space: nowrap;
  max-width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-transform: none;
  display:inline-flex;
}
input[type=textadd] {

    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    /*background-image: url('../assets/image/group.png');*/
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 12px 12px 12px 12px;
    -webkit-transition: width 0.4s ease-in-out;
    transition: width 0.4s ease-in-out;
}
textarea:focus {
    outline: none !important;
}


.headerOut__dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  height: 4rem;
  min-width: 170px;
  overflow-y: auto;
  padding: 1rem 1rem 0rem 0;
  margin-top: 0rem;
  border-radius: 8px;
  background-color: white;
  border: 1px solid #dadce0;
  background-clip: padding-box;
}
.headerOut__dropdown-menu-link {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  line-height: 0;
  color: #3c4043;
  padding: 0.3rem 1.5rem 0.3rem 1.5rem;
  margin-bottom: 0.4rem;
  border-radius: 0 50px 50px 0;
}
.headerOut__dropdown-menu-link:hover {
  background-color: #b4d1f478;
  color: #2562af;
}
.headerOut__dropdown-menu-link:hover .headerOut--icon--menu {
  color: #2562af;
}
.headerOut__dropdown-menu-svg {
  padding-right: 16px;
}
.headerOut__dropdown-menu-svg.headerOut--icon {
  width: 1.40rem;
  height: 1.40rem;
}
.headerOut__dropdown-menu-svg.headerOut--icon--menu {
  width: 1.40rem;
  height: 1.40rem;
}


.header__dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  height: 25rem;
  min-width: 215px;
  overflow-y: auto;
  padding: 1rem 1rem 0rem 0;
  margin-top: 0rem;
  border-radius: 8px;
  background-color: white;
  border: 1px solid #dadce0;
  background-clip: padding-box;
}
.header__dropdown-menu-link {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  line-height: 0;
  color: #3c4043;
  padding: 0.3rem 1.5rem 0.3rem 1.5rem;
  margin-bottom: 0.4rem;
  border-radius: 0 50px 50px 0;
  width: 170px;
}
.header__dropdown-menu-link:hover {
  background-color: #b4d1f478;
  color: #2562af;
}
.header__dropdown-menu-link:hover .header--icon--menu {
  color: #2562af;
}
.header__dropdown-menu-svg {
  padding-right: 16px;
}
.header__dropdown-menu-svg.header--icon {
  width: 1.40rem;
  height: 1.40rem;
}
.header__dropdown-menu-svg.header--icon--menu {
  width: 1.40rem;
  height: 1.40rem;
}


.headerUser {
  margin-top: 15px;
}

.headerUser__nav {
  position: relative;
}
.headerUser__navbar {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
}
.headerUser__item {
  padding: 1rem;
  position: relative;
}
.headerUser--icon {
  font-size: 20px;
  color: white !important;
}
.headerUser--icon--menu {
  color: gray;
}
.headerUser--btn {
  top: 0;
  right: 0;
  position: absolute;
}
.headerUser--btn:focus {
  outline:none;
}
.headerUser--icon, .headerUser--icon--menu {
  fill: currentcolor;
  width: 1.65rem;
  height: 1.65rem;
  display: inline-flex;
}
.headerUser--btn {
  cursor: pointer;
  padding: 0;
  display: inline-block;
  border: 1px solid transparent;
  background-color: transparent;
  appearance: none;
  user-select: none;
}
.headerUser__dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  height: 7rem;
  width: 175px;
  overflow-y: auto;
  padding: 7px 1rem 0rem 0;
  margin-top: 0rem;
  border-radius: 8px;
  background-color: white;
  border: 1px solid #dadce0;
  background-clip: padding-box;
  /* justify-content: center; */
  display: flex;
  align-items: center;
}
.headerUser__dropdown-menu-link {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  line-height: 0;
  color: #3c4043;
  padding: 0.3rem 1.5rem 0.3rem 1.5rem;
  margin-bottom: 0.4rem;
  border-radius: 0 50px 50px 0;
}
.headerUser__dropdown-menu-link:hover {
  background-color: #b4d1f478;
  color: #2562af;
}
.headerUser__dropdown-menu-link:hover .headerUser--icon--menu {
  color: #2562af;
}
.headerUser__dropdown-menu-svg {
  padding-right: 16px;
}
.headerUser__dropdown-menu-svg.headerUser--icon {
  width: 1.40rem;
  height: 1.40rem;
}
.headerUser__dropdown-menu-svg.headerUser--icon--menu {
  width: 1.40rem;
  height: 1.40rem;
}

/*// Dropdown animation*/
.dropdown-enter-active, .dropdown-leave-active {
  transition: all 0.3s;
}
.dropdown-enter, .dropdown-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
.wrapper {
  height: 70vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.wrapper.social {
  margin-top: 1rem;
}
.wrapper a {
  padding: 0.6rem;
}
.wrapper h1 {
  color: #42b983;
  font-size: 2rem;
  font-weight: 300;
}
.wrapper p {
  color: #7f8c8d;
  font-weight: 100;
}
.wrapper svg {
  fill: currentcolor;
  color: #b8c2cc;
  width: 1.65rem;
  height: 1.65rem;
  display: inline-flex;
}
ul {
  margin: 0;
  padding: 0;
}

h1 { margin: 0 }
li { list-style: none; }
a { text-decoration: none; }

hr {
  border: 0;
  height: 0;
  margin: 5px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary {
  z-index: 8 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/notes/NoteDialog.vue